import gql from 'graphql-tag';

const query = gql`
  query SalePaymentGetByToken($token: String!) {
    sale {
      payment {
        getByToken(token: $token) {
          id
          description
          status
          isCod
          containsPhysicalProduct
          price {
            amount
            currency
          }
          products {
            id
            price {
              amount
              currency
            }
            saleProductVariant {
              id
              saleProduct {
                id
                name
                productCardTitle
                isVirtual
                price {
                  regular {
                    amount
                    currency
                  }
                  promo {
                    amount
                    currency
                  }
                }
              }
            }
          }
          shipping {
            price {
              amount
              currency
            }
            saleShipping {
              id
            }
          }
          user {
            id
            email
            shipping {
              name
              street
              city
              postalCode
              phone
              country {
                code
                name
              }
            }
          }
        }
      }
    }
  }
`;

export default query;
